/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type InternalUserDetailResponse,
    InternalUserDetailResponseFromJSON,
    InternalUserDetailResponseToJSON,
} from '../models/InternalUserDetailResponse';
import {
    type InternalUserResponsePagedResult,
    InternalUserResponsePagedResultFromJSON,
    InternalUserResponsePagedResultToJSON,
} from '../models/InternalUserResponsePagedResult';
import {
    type InternalUserSearchRequest,
    InternalUserSearchRequestFromJSON,
    InternalUserSearchRequestToJSON,
} from '../models/InternalUserSearchRequest';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/ProblemDetails';
import {
    type SectionResponse,
    SectionResponseFromJSON,
    SectionResponseToJSON,
} from '../models/SectionResponse';

export interface ApiInternalUsersInternalUserIdDeleteRequest {
    internalUserId: string;
    deleteB2CUser?: boolean;
}

export interface ApiInternalUsersInternalUserIdGetRequest {
    internalUserId: string;
}

export interface ApiInternalUsersSearchesPostRequest {
    internalUserSearchRequest: InternalUserSearchRequest;
}

/**
 * 
 */
export class InternalUsersApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiInternalUsersEmploymentCategoriesGet without sending the request
     */
    async apiInternalUsersEmploymentCategoriesGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/internal-users/employment-categories`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiInternalUsersEmploymentCategoriesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.apiInternalUsersEmploymentCategoriesGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiInternalUsersEmploymentCategoriesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.apiInternalUsersEmploymentCategoriesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiInternalUsersInternalUserIdDelete without sending the request
     */
    async apiInternalUsersInternalUserIdDeleteRequestOpts(requestParameters: ApiInternalUsersInternalUserIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['internalUserId'] == null) {
            throw new runtime.RequiredError(
                'internalUserId',
                'Required parameter "internalUserId" was null or undefined when calling apiInternalUsersInternalUserIdDelete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['deleteB2CUser'] != null) {
            queryParameters['deleteB2CUser'] = requestParameters['deleteB2CUser'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/internal-users/{internalUserId}`;
        urlPath = urlPath.replace('{internalUserId}', encodeURIComponent(String(requestParameters['internalUserId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiInternalUsersInternalUserIdDeleteRaw(requestParameters: ApiInternalUsersInternalUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiInternalUsersInternalUserIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiInternalUsersInternalUserIdDelete(requestParameters: ApiInternalUsersInternalUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiInternalUsersInternalUserIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiInternalUsersInternalUserIdGet without sending the request
     */
    async apiInternalUsersInternalUserIdGetRequestOpts(requestParameters: ApiInternalUsersInternalUserIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['internalUserId'] == null) {
            throw new runtime.RequiredError(
                'internalUserId',
                'Required parameter "internalUserId" was null or undefined when calling apiInternalUsersInternalUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/internal-users/{internalUserId}`;
        urlPath = urlPath.replace('{internalUserId}', encodeURIComponent(String(requestParameters['internalUserId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiInternalUsersInternalUserIdGetRaw(requestParameters: ApiInternalUsersInternalUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InternalUserDetailResponse>> {
        const requestOptions = await this.apiInternalUsersInternalUserIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiInternalUsersInternalUserIdGet(requestParameters: ApiInternalUsersInternalUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InternalUserDetailResponse> {
        const response = await this.apiInternalUsersInternalUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiInternalUsersSearchesPost without sending the request
     */
    async apiInternalUsersSearchesPostRequestOpts(requestParameters: ApiInternalUsersSearchesPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['internalUserSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'internalUserSearchRequest',
                'Required parameter "internalUserSearchRequest" was null or undefined when calling apiInternalUsersSearchesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/internal-users/searches`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalUserSearchRequestToJSON(requestParameters['internalUserSearchRequest']),
        };
    }

    /**
     */
    async apiInternalUsersSearchesPostRaw(requestParameters: ApiInternalUsersSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InternalUserResponsePagedResult>> {
        const requestOptions = await this.apiInternalUsersSearchesPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalUserResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiInternalUsersSearchesPost(requestParameters: ApiInternalUsersSearchesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InternalUserResponsePagedResult> {
        const response = await this.apiInternalUsersSearchesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiInternalUsersSectionsGet without sending the request
     */
    async apiInternalUsersSectionsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/internal-users/sections`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiInternalUsersSectionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SectionResponse>>> {
        const requestOptions = await this.apiInternalUsersSectionsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SectionResponseFromJSON));
    }

    /**
     */
    async apiInternalUsersSectionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SectionResponse>> {
        const response = await this.apiInternalUsersSectionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiInternalUsersWorkLocationsGet without sending the request
     */
    async apiInternalUsersWorkLocationsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/internal-users/work-locations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiInternalUsersWorkLocationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.apiInternalUsersWorkLocationsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiInternalUsersWorkLocationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.apiInternalUsersWorkLocationsGetRaw(initOverrides);
        return await response.value();
    }

}
